import { useZxing } from "react-zxing";

export const BarcodeScanner = (props) => {
  const deviceId = props.deviceId;
  console.log(deviceId);
  const { ref } = useZxing({
    paused: !deviceId,
    deviceId,
    onDecodeResult(result) {
      props.onResult(result.getText());
    },
    onDecodeError(error) {
      props.onError(error);
    },
    onError(error) {
      props.onError(error);
    },
  });

  return (
    <>
      <video className="scanner" ref={ref} />
    </>
  );
};
